import { translation as t } from "../utils/translation";
import { ICONS, IMAGES } from "../assets";
const HeaderBanner = () => {
  return (
    <div id="headerBanner" className="flex justify-between">
      <img className="flex-2 ml-5 rounded-r-m" src={IMAGES.BANNER} />
      <div className="flex-1 flex justify-center items-center rounded-l-m bg-lightBlue">
        <img
          src={ICONS.LOGO}
          alt={t.ACCESSIBILITY.LOGO_LEUMI}
          title={t.ACCESSIBILITY.LOGO_LEUMI}
        />
      </div>
    </div>
  );
};
export default HeaderBanner